import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const ACTIVATE_ACCOUNT_MUTATION = gql`
  mutation activateAccount($id: String) {
    activateAccount(where: { id: $id }) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ActivateAccountMutation extends Mutation<RootMutation> {
  document = ACTIVATE_ACCOUNT_MUTATION;
}
